import { render, staticRenderFns } from "./AllSaleStat.vue?vue&type=template&id=70b92979&scoped=true&"
import script from "./AllSaleStat.vue?vue&type=script&lang=js&"
export * from "./AllSaleStat.vue?vue&type=script&lang=js&"
import style0 from "./AllSaleStat.vue?vue&type=style&index=0&id=70b92979&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b92979",
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QPageContainer,QSelect,QBtn,QToggle});
